import { SESSION_STORAGE_FOOD_NOISE } from "components/Profile/constants";
import { SCORED } from "config/tags";
import { Answer } from "types/answer";
import type { ProfileFoodNoise } from "types/profile";
import type { Question } from "types/question";
import type { ResultsFoodNoiseType } from "types/results";
import { findAnswersByQuestionTag } from "utils/questions";

function getScore(sum: number, gender: ProfileFoodNoise["gender"]) {
  // From Google sheets function =ROUND(NORMDIST(SCORE, 6.06, 5.06, TRUE) * 100, 2)
  const scoresM = [
    11.55, 15.87, 21.12, 27.27, 34.2, 41.7, 49.53, 57.37, 64.93, 71.94, 78.19,
    83.55, 87.98, 91.49, 94.17, 96.14, 97.53, 98.47, 99.09, 99.47, 99.71
  ];

  // From Google sheets function =ROUND(NORMDIST(SCORE, 8.04, 5.4, TRUE) * 100, 2)
  const scoresF = [
    6.83, 9.62, 13.17, 17.53, 22.72, 28.67, 35.28, 42.36, 49.7, 57.06, 64.17,
    70.82, 76.83, 82.08, 86.51, 90.13, 92.98, 95.15, 96.74, 97.88, 98.66
  ];

  const scores = {
    M: scoresM,
    F: scoresF
  };

  return scores[gender][sum];
}

export const getResultsPageFoodNoise = (
  answers: Answer[],
  questions: Question[],
  profile: ProfileFoodNoise
): ResultsFoodNoiseType & { uuid: string } => {
  const scoredAnswers = findAnswersByQuestionTag(SCORED, answers, questions);
  const gender = profile?.gender || "F";

  const sum = scoredAnswers.reduce((acc, answer) => {
    return acc + parseInt(answer.answers[0].value, 10);
  }, 0);

  const score = getScore(sum, gender);

  const sessionStorageFoodNoise = window.sessionStorage?.getItem(
    SESSION_STORAGE_FOOD_NOISE
  );
  const {
    uuid,
    isActive,
    emailStatus,
  } = JSON.parse(sessionStorageFoodNoise || "{}");

  return {
    sum,
    score,
    uuid,
    isActive,
    emailStatus
  };
};
